import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const hybridWaterfallRoutes: RouteObject = {
  id: "capitalActivityCapitalActivityEventWaterfallHybrid",
  path: "hybrid/:fundFamilySubEventId",
  children: [
    {
      id: "capitalActivityCapitalActivityEventWaterfallHybridInput",
      path: "input",
      lazy: async () => {
        const { HybridWaterfallInputPage } = await import(
          "features/waterfall/hybrid/HybridWaterfallInputPage"
        );
        return { Component: HybridWaterfallInputPage };
      },
      children: [
        {
          id: "capitalActivityCapitalActivityEventWaterfallHybridRequiredPaydownInput",
          path: "required-paydown",
          lazy: async () => {
            const { RequiredPaydownInputPage } = await import(
              "features/waterfall/hybrid/RequiredPaydownInputPage"
            );
            return { Component: RequiredPaydownInputPage };
          },
          handle: {
            title: i18n.t("waterfall:hybrid.requiredPaydownInput.breadcrumb"),
          },
        },
        {
          id: "capitalActivityCapitalActivityEventWaterfallHybridAcceleratedPaydownInput",
          path: "accelerated-paydown",
          lazy: async () => {
            const { AcceleratedPaydownInputPage } = await import(
              "features/waterfall/hybrid/AcceleratedPaydownInputPage"
            );
            return { Component: AcceleratedPaydownInputPage };
          },
          handle: {
            title: i18n.t(
              "waterfall:hybrid.acceleratedPaydownInput.breadcrumb",
            ),
          },
        },
      ],
    },
    {
      id: "capitalActivityCapitalActivityEventWaterfallHybridInputReview",
      path: "review-inputs",
      lazy: async () => {
        const { InputReviewPage } = await import(
          "features/waterfall/hybrid/InputReviewPage"
        );
        return { Component: InputReviewPage };
      },
      children: [],
    },
    {
      id: "capitalActivityCapitalActivityEventWaterfallHybridExpenseAllocations",
      path: "expense-allocations",
      lazy: async () => {
        const { ReviewExpenseAllocationsPage } = await import(
          "features/waterfall/hybrid/ReviewExpenseAllocationsPage"
        );
        return { Component: ReviewExpenseAllocationsPage };
      },
      children: [],
    },
  ],
};
